<button
   class="sam-full-height sam-no-margin sam-no-padding"
   kendoButton
   kendoTooltip
   [title]="toolTipText"
   (click)="onButtonClick($event)"
>
   <fa-icon [icon]="clearFilterIcon" [fixedWidth]="true"></fa-icon>
</button>
